import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { fileUrl, imgUrl, imgSrcSet } from "@/lib/api";
import { useMoney } from "@/context/CurrencyContext";
import { VideoSlot } from "@/components/VideoSlot";
import { RoomPreview } from "@/components/RoomPreview";
import { WallPhotoPreview } from "@/components/WallPhotoPreview";
import { ArtMockup, parseSize } from "./ArtMockup";

const Img = ({ u, alt, className = "" }) => (
  <div className={`art-image-wrap bg-cream-soft relative ${className}`}>
    <img src={imgUrl(fileUrl(u), 960)} srcSet={imgSrcSet(fileUrl(u))} sizes="(min-width: 1024px) 55vw, 100vw" loading="lazy" decoding="async" alt={alt} className="w-full object-cover" />
  </div>
);

// Left column: mockup / originals photos, badges, room + wall previews, page videos.
export const ProductGallery = ({ art, activeSize, material, frame, soldOut }) => {
  const roomDims = parseSize(activeSize?.size || art.sizes?.[0]?.size);
  const primary = fileUrl(art.image_urls?.[0]);
  return (
    <div className="space-y-4">
      {art.prints_only
        ? <ArtMockup art={art} size={activeSize} material={material} frame={frame} />
        : (art.image_urls || []).map(u => <Img key={u} u={u} alt={art.title} />)}
      <div className="flex gap-2">
        {soldOut && <span className="badge-art badge-sold">Sold</span>}
        {art.prints_only && <span className="badge-art badge-prints">Prints Only Available</span>}
      </div>
      {art.prints_only && (art.image_urls || []).slice(1).map(u => <Img key={u} u={u} alt={art.title} className="mt-2" />)}
      {roomDims && (
        <div className="pt-6">
          <RoomPreview src={primary} title={art.title} w={roomDims[0]} h={roomDims[1]} frameColor={frame?.frame_color || null} />
          <div className="mt-6"><WallPhotoPreview src={primary} title={art.title} w={roomDims[0]} h={roomDims[1]} /></div>
        </div>
      )}
      <VideoSlot page="artwork" spot="under_images" artworkId={art.id} className="pt-6" />
    </div>
  );
};

export const PurchaseActions = ({ soldOut, totalPrice, onAdd, onBuyNow }) => {
  const money = useMoney();
  if (soldOut) {
    return (
      <div className="border-t border-ink-10 pt-8">
        <p className="text-ink-soft mb-4">This original has found its home. Reach out for commissioned work in a similar spirit.</p>
        <Link to="/custom" className="btn-ink" data-testid="detail-commission-btn">Commission Something Similar</Link>
      </div>
    );
  }
  return (
    <div className="space-y-3">
      <button onClick={onBuyNow} className="btn-ink w-full" data-testid="buy-now-btn">Buy Now · {money(totalPrice)}</button>
      <button onClick={onAdd} className="btn-outline w-full justify-center" data-testid="add-to-cart-btn"><ShoppingBag size={14}/> Add to Cart</button>
      <p className="text-xs text-mute text-center pt-2">Secure checkout via Stripe — card, Apple Pay, Google Pay, Cash App Pay, or Link. Charged in USD.</p>
    </div>
  );
};
